import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import {
  DeliveryFeeType,
  DeliveryProvider,
} from '@/pages/camel-order/delivery/service';
import { CamelOrderDeliveryService } from '@/services/Delivery/CamelOrderDeliveryService';

export type DeliveryUpsertParams = {
  site_id: string;
  delivery_fee_type: DeliveryFeeType;
  base_delivery_fee: number | null;
  base_delivery_fee_distance: number | null;
  additional_distance_fee: number | null;
  additional_distance: number | null;
  fixed_discount_amount: number | null;
  preference_type: string;
  delivery_providers: DeliveryProvider[];
  uber_direct_customer_id: string | null;
  wolt_drive_merchant_id: string | null;
  wolt_drive_key: string | null;
};

export const useCamelOrderDeliveryUpsert = async (
  params: DeliveryUpsertParams
): Promise<void> => {
  const camelOrderDeliveryService = new CamelOrderDeliveryService(getClient());
  try {
    return await camelOrderDeliveryService.upsert(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
